import { title } from "process";

export class GlobalConstants {
  public static appInfo = {
    header_appTitle: ' | Hospital Supply Management',
    footer_appTitle: 'Hospital Supply Management',
    appVersion: '4.0',
  };

  public static mainNav = [
    {
      title: 'Sites',
      route: 'sites',
    },
    {
      title: 'Reports',
      children: [
        { title: 'Inventory on Hand', route: 'reports' },
        { title: 'Open Purchase Orders', route: 'poreports' },
        { title: 'Par-File Audit Report', route: 'auditreports' },
        { title: 'Item Expiration Report', route: 'auditreports' },
        { title: 'OOS Report', route: 'auditreports' },
        { title: 'Count Submission Report', route: 'auditreports' },
        { title: 'MOM Report', route: 'auditreports' }
      ]
    },
    {
      title: 'User Management',
      route: 'user-management'
    }
  ];

  public static mainNav_oracle = [
    {
      title: 'Inventory Organizations',
      route: 'sites',
    },
    {
      title: 'Reports',
      children: [
        { title: 'Inventory on Hand', route: 'reports' },
        { title: 'Open Purchase Orders', route: 'poreports' },
        { title: 'Par-File Audit Report', route: 'auditreports' },
        { title: 'Item Expiration Report', route: 'auditreports' },
        { title: 'OOS Report', route: 'auditreports' },
        { title: 'Count Submission Report', route: 'auditreports' },
        { title: 'MOM Report', route: 'auditreports' }
      ]
    },
    {
      title: 'User Management',
      route: 'user-management'
    }
  ];

  public static interfacesReletivePath = `interfaces`
  // public static mainNav = [
  //   {
  //     title: ' Sites',
  //     route: '/sites',
  //   }, {
  //     title: 'Reports',
  //     children:[
  //       {
  //         title: ' Inventory on Hand',
  //         route: '/reports',
  //       },
  //       {
  //         title: ' Open Purchase Orders',
  //         route: '/poreports',
  //       },
  //       {
  //         title: 'Par-File Audit Report',
  //         route: '/auditreports'
  //       },
  //       {
  //         title: 'Item Expiration Report',
  //         route: '/auditreports'
  //       },
  //       {
  //         title: 'OOS Report',
  //         route: '/auditreports'
  //       },
  //       {
  //         title: 'Count Submission Report',
  //         route: '/auditreports'
  //       },
  //       {
  //         title: 'MOM Report',
  //         route: '/auditreports'
  //       },

  //     ]
    
  //   },
  //   {
  //     title: 'User Management',
  //     route: '/user-management'
  //   }
  // ];
}